<script>
  import { _ } from 'svelte-i18n';
  export let feedbackSelected = '';
  export let type = 'positive';
  export let cssClass = '';

  const options = {
    positive: [
      { id: 'radio-1', label: $_('step1.positiveRating.options.clearInstructions'), value: 'CHIARE' },
      { id: 'radio-2', label: $_('step1.positiveRating.options.completeInstructions'), value: 'COMPLETE' },
      { id: 'radio-3', label: $_('step1.positiveRating.options.clearProcedure'), value: 'CAPIVO' },
      { id: 'radio-4', label: $_('step1.positiveRating.options.noTechnicalIssues'), value: 'NO_PROBLEMI_TECNICI' },
      { id: 'radio-5', label: $_('common.other'), value: 'ALTRO' },
    ],
    negative: [
      { id: 'radio-6', label: $_('step1.negativeRating.options.unclearInstructions'), value: 'NO_CHIARE' },
      { id: 'radio-7', label: $_('step1.negativeRating.options.incompleteInstructions'), value: 'NO_COMPLETE' },
      { id: 'radio-8', label: $_('step1.negativeRating.options.ambiguousProcedure'), value: 'NON_CAPIVO' },
      { id: 'radio-9', label: $_('step1.negativeRating.options.technicalIssues'), value: 'PROBLEMI_TECNICI' },
      { id: 'radio-10', label: $_('common.other'), value: 'ALTRO' },
    ],
  };
</script>

<div class="{cssClass}" data-step="1">
  <div class="cmp-steps-rating">
    <!-- Positive feedbacks -->
    <fieldset
      class="fieldset-rating-one"
      class:d-none={type === 'negative'}
      data-element="feedback-rating-positive"
    >
      <legend class="iscrizioni-header w-100">
        <h3
          class="step-title d-flex flex-column flex-lg-row align-items-lg-center justify-content-between drop-shadow"
        >
          <span class="d-block text-wrap" data-element="feedback-rating-question">
            {$_(`step1.${type}Rating.question`)}
          </span>
          <span class="step">{$_('common.step1')}</span>
        </h3>
      </legend>
      <div class="cmp-steps-rating__body pt-0">
        <div class="cmp-radio-list">
          <div class="card card-teaser shadow-rating">
            <div class="card-body">
              <div class="form-check m-0">
                {#each options.positive as fb}
                  <div class="radio-body border-bottom border-light cmp-radio-list__item">
                    <input
                      type="radio"
                      id={fb.id}
                      name="rating1"
                      value={fb.value}
                      bind:group={feedbackSelected}
                      required
                    />
                    <label for={fb.id} class="fw-semibold" data-element="feedback-rating-answer">
                      {fb.label}
                    </label>
                  </div>
                {/each}
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <!-- Negative feedbacks -->
    <fieldset
      class="fieldset-rating-one"
      class:d-none={type === 'positive'}
      data-element="feedback-rating-negative"
    >
      <legend class="iscrizioni-header w-100">
        <h6
          class="step-title d-flex flex-column flex-lg-row align-items-lg-center justify-content-between drop-shadow"
        >
          <span class="d-block text-wrap" data-element="feedback-rating-question">
            {$_(`step1.${type}Rating.question`)}
          </span>
          <span class="step">{$_('common.step1')}</span>
        </h6>
      </legend>
      <div class="cmp-steps-rating__body pt-0">
        <div class="cmp-radio-list">
          <div class="card card-teaser shadow-rating">
            <div class="card-body">
              <div class="form-check m-0">
                {#each options.negative as fb}
                  <div class="radio-body border-bottom border-light cmp-radio-list__item">
                    <input
                      type="radio"
                      id={fb.id}
                      name="rating1"
                      value={fb.value}
                      bind:group={feedbackSelected}
                      required
                    />
                    <label for={fb.id} class="fw-semibold" data-element="feedback-rating-answer">
                      {fb.label}
                    </label>
                  </div>
                {/each}
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</div>
